import { getCsrf, setCsrf } from '@applyboard/ui-utils';
export { setCsrf };
export default getCsrf;